import React from 'react';
import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon, Loader, Dimmer
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import FreteCerto from './FreteCerto.js'


function EntregaCertaPainel(props) {


    let panes = [
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='truck' />Frete Certo</Menu.Item>,
            render: () =>
                <FreteCerto />,
        },
    ]

    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Frete Certo</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>

            
            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>

        </div>
    );
}

const mapStateToProps = (state) => ({

})
export default withRouter(connect(mapStateToProps, {

}
)(EntregaCertaPainel));